import React, { CSSProperties } from "react";
import Display from "../../../components/Display";
import { CyclingPowerEventData } from "../../CyclingPowerEventData";
import VirtualSensors from "../../VirtualSensors";

class VirtualHRSensorState 
{
    Value: number = 70;
}

export class VirtualHRSensor extends React.Component<any, VirtualHRSensorState>
{
    constructor(props: any)
    {
        super(props);
        this.state = new VirtualHRSensorState();
        VirtualSensors.HRSensor.setValue(this.state.Value);
    }

    render()
    {
        return (
            <div>
                <div>Virtual HR Mon</div>
                <Display header="VHRS" value="125" footer="footer">
                    <div style={innerStyle}>{this.state.Value}</div>
                </Display>
                <button style={style} onClick={() => this.increaseValue(1)}>+</button>
                <button style={style} onClick={() => this.increaseValue(-1)}>-</button>
            </div>
        );
    }

    increaseValue(amount: number)
    {
        let newValue = this.state.Value + amount;
        if (newValue < 0)
            newValue = 0;
        this.setState({Value: newValue});
        VirtualSensors.HRSensor.setValue(newValue);
    }
}

class VirtualPowermeterState
{
    Power: number = 150;
    Cadence: number = 70;
}

export class VirtualPowermeter extends React.Component<any, VirtualPowermeterState>
{
    constructor(props: VirtualPowermeterState)
    {
        super(props);
        this.state = new VirtualPowermeterState();
        VirtualSensors.CPSensor.setValue(CyclingPowerEventData.Create(this.state.Power, this.state.Cadence, 0));
    }
    
    render()
    {
        return (
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>Virtual Powermeter</div>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div>
                        <Display header="PWR" value="125" footer="footer">
                            <div style={innerStyle}>{this.state.Power}</div>
                        </Display>
                        <button style={style} onClick={() => this.increasePower(10)}>+</button>
                        <button style={style} onClick={() => this.increasePower(-10)}>-</button>
                    </div>
                    <div>
                        <Display header="CAD" value="125" footer="footer">
                            <div style={innerStyle}>{this.state.Cadence}</div>
                        </Display>
                        <button style={style} onClick={() => this.increaseCadence(1)}>+</button>
                        <button style={style} onClick={() => this.increaseCadence(-1)}>-</button>
                    </div>
                </div>
            </div>
        );
    }

    increasePower(amount: number)
    {
        let newValue = this.state.Power + amount;
        if (newValue <= 0)
            newValue = 0;
        this.setState({ Power: newValue });
        VirtualSensors.CPSensor.setValue(CyclingPowerEventData.Create(newValue, this.state.Cadence, 0));
    }

    increaseCadence(amount: number)
    {
        let newValue = this.state.Cadence + amount;
        if (newValue <= 0)
            newValue = 0;
        this.setState({ Cadence: newValue });
        VirtualSensors.CPSensor.setValue(CyclingPowerEventData.Create(this.state.Power, newValue, 0));
    }
}

export class VirtualTrainer extends React.Component<any, VirtualPowermeterState>
{
    constructor(props: VirtualPowermeterState)
    {
        super(props);
        this.state = new VirtualPowermeterState();
        VirtualSensors.Trainer.setPower(this.state.Power);
        VirtualSensors.Trainer.setCadence(this.state.Cadence);
    }
    
    render()
    {
        return (
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>Virtual Trainer</div>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div>
                        <Display header="PWR" value="125" footer="footer">
                            <div style={innerStyle}>{this.state.Power}</div>
                        </Display>
                        <button style={style} onClick={() => this.increasePower(10)}>+</button>
                        <button style={style} onClick={() => this.increasePower(-10)}>-</button>
                    </div>
                    <div>
                        <Display header="CAD" value="125" footer="footer">
                            <div style={innerStyle}>{this.state.Cadence}</div>
                        </Display>
                        <button style={style} onClick={() => this.increaseCadence(1)}>+</button>
                        <button style={style} onClick={() => this.increaseCadence(-1)}>-</button>
                    </div>
                </div>
                <div>TargetPower: {VirtualSensors.Trainer.targetPower}</div>
            </div>
        );
    }

    increasePower(amount: number)
    {
        let newValue = this.state.Power + amount;
        if (newValue <= 0)
            newValue = 0;
        this.setState({ Power: newValue });
        VirtualSensors.Trainer.setPower(newValue);
    }

    increaseCadence(amount: number)
    {
        let newValue = this.state.Cadence + amount;
        if (newValue <= 0)
            newValue = 0;
        this.setState({ Cadence: newValue });
        VirtualSensors.Trainer.setCadence(newValue);
    }
}

const style: CSSProperties = {
    width: "50px"
}

const innerStyle: CSSProperties = {
    display: "inline-block",
    fontSize: "2rem",
    alignSelf: "center"
}